import React, { Component } from 'react';
import API from 'API';
import Loader from 'components/common/Loader';
import TextHelpers from 'helpers/TextHelpers';

//-------------------------------------------------------------------------------------------------------------------

class ConfirmPrice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const { bookingRequest } = this.props;
        const { price, duration } = await API.call('book/get-price-and-duration', bookingRequest);
        this.setState({
            isLoading: false,
            price,
            duration
        });
    }

    render() {
        return (<>
            <h2>Your Price Estimate</h2>
            {this.renderInner()}
        </>);
    }

    renderInner() {
        const { onBackClicked, onNextClicked, accountInfo, bookingRequest } = this.props;
        const { isLoading, price, duration } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>
            <p className="subtitle">
                Your estimated sweep price is
            </p>
            <p className="est-price">
                {TextHelpers.formatCurrency(price)}
                {accountInfo.isVATRegistered &&
                    <span className="including-vat">Including VAT</span>
                }
            </p>
            <p className="subtitle">
                This assumes a standard sweep for
                {' '}
                {bookingRequest.chimneyTypeIDs.length == 1 ? 'one chimney' : `${bookingRequest.chimneyTypeIDs.length} chimneys`}
                {' '}
                with no blockages (such as nests).
                <br /><br />
                <a className="btn mt-3" href={'tel:' + (accountInfo.landlineTel || '').replace(/[^0-9]/g, '')}>
                    If you need a nest removed or cowl fitted, <br />
                    please call us on {accountInfo.landlineTel}
                </a>
            </p>

            <div className="nav-buttons">

                <button
                    type="button"
                    className="btn btn-secondary me-auto"
                    onClick={() => onBackClicked()}
                >
                    Back
                </button>

                <button type="button" className="btn ms-auto" onClick={() => onNextClicked()}>
                    Next
                </button>

            </div>

        </>);
    }
    
}

export default ConfirmPrice;